import CEDEMPbyLCSandPCforProduct from "pages/Evaluation/Product/filters/CEDEMPbyLCSandPCforProduct";
import shipmentTagForSubstanceByShipmentID
    from "pages/Evaluation/Product/generators/shipmentTagForSubstanceByShipmentID";
import theme from "source/theme";
import { PC } from "utils/constants/descriptorTypes";
import { lcsNames } from "utils/constants/lcsTypes";

export default (product, evaluationScenario, lcs, allScenarios, shipmentsById, lcsById, rawMaterialsById) => {
    const flatScenarios = [];

    const typesOfProducts = evaluationScenario.descritores.filter(desc => desc.id_tipo === PC).map(desc => desc.codigo);

    const CEDEMPunderAnalaysis = CEDEMPbyLCSandPCforProduct(product, typesOfProducts, lcs, allScenarios, shipmentsById, rawMaterialsById);

    const dangerousSubstancesIds = product.Produto_Mps.filter(s => s.contribui_perigo).map(s => s.id_mp.id);

    let shipmentTagForSubstanceByShipmentIDdict = {};
    dangerousSubstancesIds.forEach(dsID => {
        shipmentTagForSubstanceByShipmentIDdict = {
            ...shipmentTagForSubstanceByShipmentIDdict,
            ...shipmentTagForSubstanceByShipmentID(dsID, rawMaterialsById)
        };
    });

    CEDEMPunderAnalaysis.forEach(scenario => {
        flatScenarios.push(
            [
                { text: scenario.codigo, colSpan: 1 },
                { text: lcsNames[lcsById[parseInt(scenario.id_lcs)].id], colSpan: 1 },
                { text: scenario.designacao, colSpan: 1 },
                {
                    text: shipmentTagForSubstanceByShipmentIDdict[scenario.id_substancia_fornecedor],
                    colSpan: 1
                },
                { text: scenario.notas, colSpan: 1 }
            ]
        );
    });

    // PDF Make Table partial object
    return {
        style: 'tableExample',
        layout: 'lightHorizontalLines',
        table: {
            headerRows: 0,
            widths: [80, 60, 60, 165, 100],
            body: [
                [
                    { text: "Codigo", colSpan: 1, fillColor: theme.palette.primary.main },
                    { text: "LCS", colSpan: 1, fillColor: theme.palette.primary.main },
                    { text: "Designação", colSpan: 1, fillColor: theme.palette.primary.main },
                    { text: "Fornecimento", colSpan: 1, fillColor: theme.palette.primary.main },
                    { text: "Notas", colSpan: 1, fillColor: theme.palette.primary.main }
                ],
                ...flatScenarios
            ]
        }
    };

};